import { createRouter, createWebHashHistory } from 'vue-router'

// Import delle pagine
import Home from '../pages/Home.vue'


import Aegent from '../pages/Aegent.vue'
import AuthCallback from '../pages/AuthCallback.vue'
import PersonDetail from '../pages/PersonDetail.vue'
import ProjectDetail from '../pages/ProjectDetail.vue'
import ProjectManagement from '../components/ProjectManagement.vue'
import PeopleManagement from '../components/PeopleManagement.vue'
import BudgetManagement from '../components/BudgetManagement.vue'
import OrganisationManagement from '../components/OrganisationManagement.vue'
import DbmngTest from '../pages/DbmngTest.vue'
import Dashboard from '../pages/Dashboard.vue'


const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/aegent",
    name: "Aegent",
    component: Aegent,
  },
  {
    path: "/projects",
    name: "Projects",
    component: ProjectManagement,
  },
  {
    path: "/projects/:id",
    name: "ProjectDetail",
    component: ProjectDetail,
    props: true,
  },
  {
    path: "/people",
    name: "People",
    component: PeopleManagement,
  },
  {
    path: '/peoples',
    name: 'Peoples',
    component: () => import('@/views/Peoples.vue')
  },
  {
    path: '/peopledetail/:id',
    name: 'PeopleDetail',
    component: () => import('@/views/PeopleDetail.vue')
  },
  {
    path: "/people/:id",
    name: "PersonDetail",
    component: PersonDetail,
    props: true,
  },
  {
    path: "/budget",
    name: "Budget",
    component: BudgetManagement,
  },
  {
    path: "/organisations",
    name: "Organisations",
    component: OrganisationManagement,
  },
  {
    path: "/dbmng-test",
    name: "DbmngTest",
    component: DbmngTest,
  },
  {
    path: "/auth/callback",
    name: "AuthCallback",
    component: AuthCallback,
    props: (route) => ({
      code: route.query.code,
      state: route.query.state,
      error: route.query.error,
    }),
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router